import axios from "axios";
// axios.defaults.withCredentials = true;

export const trackFieldPersonApi = async(setFieldPersonData) =>{
    console.log("dsjhd");
    try {
        const sendRequest = await axios.get(`${process.env.REACT_APP_API_URL}/track/trackStatus`);
        console.log(sendRequest.data);
        setFieldPersonData(sendRequest.data.data);
    } catch (error) {
        console.log(error);
    }
}